import React, { useEffect, useState } from 'react';
import ReactDOM, { unmountComponentAtNode } from 'react-dom';
import { apiHolder, inWindow } from 'api';
import ImgPreviewModal from './ImgPreviewModal';
const systemApi = apiHolder.api.getSystemApi();
const isElectron = systemApi.isElectron();
const ImgPreview = props => {
    const { visible, onCancel, data, startIndex } = props;
    if (isElectron) {
        visible && electronPreview({ data, startIndex });
        onCancel && onCancel();
        return null;
    }
    const modalProps = props;
    return React.createElement(ImgPreviewModal, Object.assign({}, modalProps));
};
const electronPreview = (props) => {
    var _a;
    const flagUrl = (_a = props.data[props.startIndex || 0]) === null || _a === void 0 ? void 0 : _a.previewUrl;
    systemApi.createWindowWithInitData('imgPreviewPage', { eventName: 'initPage', eventData: props, uniqueId: flagUrl });
};
const Content = ({ divTemp, wrap, props }) => {
    const [testshow, setTestshow] = useState(true);
    useEffect(() => {
        if (!testshow) {
            unmountComponentAtNode(divTemp);
            wrap.removeChild(divTemp);
        }
    }, [testshow]);
    return (React.createElement(ImgPreviewModal, Object.assign({ visible: testshow, onCancel: () => {
            setTestshow(false);
        } }, props)));
};
const wrapFn = () => {
    if (!inWindow()) {
        return () => {
            throw new Error('window not exist');
        };
    }
    if (document === void 0) {
        return () => {
            throw new Error('document not exist');
        };
    }
    const wrap = document.createElement('div');
    document.body && document.body.appendChild(wrap);
    return (props) => {
        if (isElectron) {
            electronPreview(props);
            return;
        }
        const divTemp = document.createElement('div');
        wrap.appendChild(divTemp);
        ReactDOM.render(React.createElement(Content, { divTemp: divTemp, wrap: wrap, props: props }), divTemp);
    };
};
ImgPreview.preview = wrapFn();
export default ImgPreview;
